module.exports = __webpack_public_path__ + "static/img/index_aboutbg.f9cd238.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index_aboutbg.png
// module id = Af/W
// module chunks = 1